import React, { useEffect, useMemo } from "react"
import { useConsultaRemessaDispatch, useConsultaRemessaState, ACTION_TYPES } from "./context/consulta-remessa-context";
import { IPublicationShipmentResponse } from "../../../model/publication-shipment/response/publication-shipment-response";
import moment from "moment";
import Chip from '@mui/material/Chip';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Button, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Paper, Select, SpeedDial } from "@mui/material";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useConsultaRemessaController } from "./context/consulta-remessa-controller";
import dayjs, { Dayjs } from "dayjs";
import SearchIcon from '@mui/icons-material/Search';
import { DetalheRemessa } from "./detalhe-remessa";
import { useNavigate, useParams } from "react-router-dom";
import ClearIcon from '@mui/icons-material/Clear';
import ApplicationAppService from "../../../application/platform/application-app-service";
import { getDataGridLocaleText, dataGridDefaultSx, dataGridDefaultProps } from "../../../config/datagrid-config";
export const ConsultaRemessa = () => {
    const { listPublicationShipmentPagedRequest, listPublicationShipmentResponse, isLoadingData, listSatusPublicatioShipment, listUsersSend } = useConsultaRemessaState();
    const { handleOnChange, getInit, clearFields, list, onChangePagination, getDetail } = useConsultaRemessaController();
    const consultaRemessaDispatch = useConsultaRemessaDispatch();
    const { publicationShipmentId } = useParams();
    const navigate = useNavigate();
    const applicationData = ApplicationAppService.getApplicationData();

    useEffect(() => {
        (async () => {
            await getInit();
            await list(listPublicationShipmentPagedRequest);

            if (publicationShipmentId !== null && publicationShipmentId !== undefined) {
                await getDetail(Number(publicationShipmentId));
            }
        })();
    }, []);


    const paginationModel = useMemo(() => ({
        page: listPublicationShipmentPagedRequest?.page ?? 0,
        pageSize: listPublicationShipmentPagedRequest?.pageSize ?? 50
    }), [listPublicationShipmentPagedRequest?.page, listPublicationShipmentPagedRequest?.pageSize]);

    const columns: GridColDef<IPublicationShipmentResponse>[] = [
        { field: 'id', headerName: 'Nº', width: 90 },
        {
            field: 'sendDate',
            headerName: 'Enviada em',
            flex: 1,
            valueFormatter: params => moment(params).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
            field: 'publishDate',
            headerName: 'Publicar em',
            flex: 1,
            valueFormatter: params => moment(params).format("DD/MM/YYYY"),
        },
        {
            field: 'title',
            headerName: 'Título',
            flex: 3
        }, {
            field: 'personEntityName',
            headerName: 'Entidade',
            flex: 3
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                let chip = <Chip label={params.row.status} color="primary" />
                if (params.row.statusId === 1) {
                    chip = <Chip label={params.row.status} color="primary" />
                } else if (params.row.statusId === 2) {
                    chip = <Chip label={params.row.status} color="secondary" />
                } else if (params.row.statusId === 3) {
                    chip = <Chip label={params.row.status} color="warning" />
                } else if (params.row.statusId === 4) {
                    chip = <Chip label={params.row.status} color="error" />
                } else if (params.row.statusId === 5) {
                    chip = <Chip label={params.row.status} color="success" />
                }
                return chip;
            }
        },
        {
            field: 'userSenderName',
            headerName: 'Enviada por',
            flex: 1
        }, {
            field: "action",
            headerName: "",
            sortable: false,
            flex: 0,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <IconButton color="primary" aria-label="Detahes" component="label" onClick={async () => {
                        await getDetail(params.row.id);
                    }}>
                        <DisplaySettingsIcon />
                    </IconButton>)
            }
        }
    ];

    return (
        <React.Fragment>
            <DetalheRemessa></DetalheRemessa>
            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid
                            container spacing={1.5}
                        >
                            <Grid
                                item
                                lg={2}
                                sm={2}
                                xl={2}
                            >
                                <InputLabel>Nº Remessa</InputLabel>
                                <OutlinedInput
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    name="input-id"
                                    size="small"
                                    value={listPublicationShipmentPagedRequest.id}
                                    defaultValue={listPublicationShipmentPagedRequest.id}
                                    onChange={handleOnChange}
                                    fullWidth

                                />
                            </Grid>
                            <Grid item lg={3}
                                sm={3}
                                xl={3}>
                                <InputLabel>Status</InputLabel>
                                <Select name="select-status" fullWidth
                                    size="small"
                                    value={listPublicationShipmentPagedRequest.statusId ?? ""}
                                    onChange={handleOnChange}
                                >
                                    {listSatusPublicatioShipment.map((element) => {
                                        return (
                                            <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </Grid>
                            <Grid item lg={3}
                                sm={3}
                                xl={3}>
                                <InputLabel>Tipo de Remessa</InputLabel>
                                <Select name="select-type" fullWidth
                                    size="small"
                                    value={listPublicationShipmentPagedRequest.types ?? ""}
                                    onChange={handleOnChange}
                                >
                                    <MenuItem value={1} key={1}>ROTINA</MenuItem>
                                    <MenuItem value={2} key={2}>URGÊNCIA</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2}>
                                <InputLabel>Data Envio Inicial</InputLabel>
                                <DesktopDatePicker
                                    format='DD/MM/YYYY'
                                    name="input-start-date"
                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    value={listPublicationShipmentPagedRequest?.startDate !== undefined ? dayjs(listPublicationShipmentPagedRequest?.startDate) : undefined}
                                    onChange={(value: Dayjs | null) => {
                                        let startDate = value?.format("YYYY-MM-DD");
                                        consultaRemessaDispatch({
                                            type: ACTION_TYPES.setListPublicationShipmentPagedRequest,
                                            payload: { ...listPublicationShipmentPagedRequest, startDate },
                                        });
                                    }}
                                />
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2}>
                                <InputLabel>Data Envio Final</InputLabel>
                                <DesktopDatePicker
                                    format='DD/MM/YYYY'
                                    name="input-end-date"
                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    value={listPublicationShipmentPagedRequest?.endDate !== undefined ? dayjs(listPublicationShipmentPagedRequest?.endDate) : undefined}
                                    onChange={(value: Dayjs | null) => {
                                        let endDate = value?.format("YYYY-MM-DD");
                                        consultaRemessaDispatch({
                                            type: ACTION_TYPES.setListPublicationShipmentPagedRequest,
                                            payload: { ...listPublicationShipmentPagedRequest, endDate },
                                        });
                                    }}
                                />
                            </Grid>
                            <Grid item lg={8}
                                sm={8}
                                xl={8}>
                                <InputLabel>Enviada por</InputLabel>
                                <Select
                                    name="select-user-id"
                                    size="small"
                                    value={listPublicationShipmentPagedRequest.userSenderId ?? ""}
                                    onChange={handleOnChange} fullWidth
                                >

                                    {listUsersSend.map((element, index) => {
                                        return (
                                            <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2} direction="row" justifyContent="flex-end"
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}
                            >
                                <Button variant="contained" fullWidth size="small" onClick={async () => {
                                    await list(listPublicationShipmentPagedRequest);
                                }} startIcon={<SearchIcon />}>Consultar</Button>
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2} direction="row" justifyContent="flex-end"
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}
                            >



                                <Button fullWidth size="small"
                                    variant="outlined"

                                    onClick={async () => {
                                        await clearFields();
                                    }} startIcon={<ClearIcon />}>Limpar</Button>
                            </Grid>

                        </Grid>
                    </LocalizationProvider>
                </Paper>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{}}>
                <Paper

                    sx={{
                        p: 2,
                        minHeight: "500px",

                        display: 'flex',

                        flexDirection: 'column'
                    }}
                >
                    <DataGrid
                        rows={listPublicationShipmentResponse.items}
                        columns={columns}
                        {...dataGridDefaultProps}
                        onPaginationModelChange={(e) => {
                            onChangePagination(e.page, e.pageSize);
                        }}
                        sx={dataGridDefaultSx}
                        localeText={getDataGridLocaleText(
                            listPublicationShipmentResponse.totalRecords,
                            listPublicationShipmentResponse.pageSize
                        )}
                        paginationModel={paginationModel}
                        rowCount={listPublicationShipmentResponse.totalRecords}
                        loading={isLoadingData}
                    />

                    {applicationData?.moduleId === 1 &&
                        <SpeedDial
                            ariaLabel="SpeedDial basic example"
                            sx={{ position: 'absolute', bottom: 16, right: 16 }}
                            onClick={() => {
                                navigate(`/envio-remessa`);
                            }}
                            icon={<SpeedDialIcon />}
                        >
                        </SpeedDial>
                    }
                </Paper>
            </Grid>
        </React.Fragment>

    )
}